<template>
  <div>
    <p-radio v-for="item in spec.items"
             :label="typeof item === 'object' ? item.value : item"
             v-model="value"
             :disabled="_readonly">{{i18n.fr(typeof item === 'object' ? item.label : item)}}
    </p-radio>
  </div>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-radio',
    mixins: [mixin],
  };
</script>



// WEBPACK FOOTER //
// f-radio.vue?147d45b4